import { ChevronLeft } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * D9 — the single back button used across the whole app.
 *
 * Fixed 56x56 (`size-14`) plus `shrink-0`, so a long neighbouring title (a
 * circle name in "manage circle", for instance) can never squeeze or squash it.
 * The chrome is Figma 🚀-Racore "Button/Circle — Back" (node 2509-9936): a blue
 * gradient ring, a 1px gap, then a dark gradient face (`btn-back-ring` /
 * `btn-back-face` in index.css). Do not re-style it at call sites: `className`
 * is for layout only (margins / self-alignment), never for size, radius or colour.
 */
export default function BackButton({
  onClick,
  className,
  ariaLabel = 'Back',
  'data-testid': testId = 'btn-back',
}: {
  onClick: () => void;
  className?: string;
  ariaLabel?: string;
  'data-testid'?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      data-testid={testId}
      className={cn(
        'tw:flex tw:size-14 tw:shrink-0 tw:rounded-[19px] tw:p-0.5 tw:text-white tw:btn-back-ring',
        className,
      )}
    >
      <span className="tw:flex tw:flex-1 tw:items-center tw:justify-center tw:rounded-2xl tw:btn-back-face">
        <ChevronLeft size={22} strokeWidth={2.5} />
      </span>
    </button>
  );
}
